import Marshal from 'marshal';

const NO_EXPERIMENT_ID = 'none';
const NO_EXPERIMENT_VARIANT = 'none';
const GA_EXPERIMENT_ID = 'dimension4';
const GA_EXPERIMENT_VARIANT = 'dimension5';
const MARSHAL_ENCODING = 'base64';

export const RB_EXPERIMENT_COOKIE = '_rb_e_data';

export const gaExperimentDimensions = ({ experiment, group }) => ({
  [GA_EXPERIMENT_ID]: experiment || NO_EXPERIMENT_ID,
  [GA_EXPERIMENT_VARIANT]: group || NO_EXPERIMENT_VARIANT
});

export const rbExperimentCookieData = parsedCookie => {
  if (!parsedCookie) return {};

  const [data] = parsedCookie.split('--');
  const parsedRailsData = new Marshal(data, MARSHAL_ENCODING).parsed;

  return JSON.parse(parsedRailsData);
};

export const readRBMSetExperimentCookie = setCookieHeader => {
  const [cookieNameAndValue] = setCookieHeader.split(';');
  if (cookieNameAndValue) {
    const [cookieName, rawCookieValue] = cookieNameAndValue.split('=');
    if (cookieName === RB_EXPERIMENT_COOKIE) {
      return rawCookieValue;
    }
  }
  return null;
};
